import EditSegmentOrTagModal from './EditSegmentOrTagModal';

export default EditSegmentOrTagModal;
